import Cookies from 'js-cookie';
import { PDP_GALLERY_QA_COVER_RANGE_COOKIE } from './constants';

export const MIN_GALLERY_QA_COVER_RANGE = 0;
export const MAX_GALLERY_QA_COVER_RANGE = 0.5;

export const parseGalleryCoverRangeOverride = (
  value?: string
): number | undefined => {
  if (!value) {
    return undefined;
  }

  const parsedValue = Number.parseFloat(value);

  if (
    !Number.isFinite(parsedValue) ||
    parsedValue < MIN_GALLERY_QA_COVER_RANGE ||
    parsedValue > MAX_GALLERY_QA_COVER_RANGE
  ) {
    return undefined;
  }

  return parsedValue;
};

export const getGalleryCoverRangeOverrideFromCookie = (): number | undefined =>
  parseGalleryCoverRangeOverride(
    Cookies.get(PDP_GALLERY_QA_COVER_RANGE_COOKIE)
  );

export const GALLERY_QA_COVER_RANGE_RESET_VALUE = 'reset';

export const getGalleryCoverRangeOverrideFromQueryParam = (
  search: string
): number | undefined | 'reset' => {
  const searchParams = new URLSearchParams(search);
  const raw = searchParams.get(PDP_GALLERY_QA_COVER_RANGE_COOKIE);

  if (raw === GALLERY_QA_COVER_RANGE_RESET_VALUE) {
    return 'reset';
  }

  return parseGalleryCoverRangeOverride(raw ?? undefined);
};

export const getGalleryCoverRangeOverride = (): number | undefined => {
  if (typeof window !== 'undefined') {
    const queryParamValue = getGalleryCoverRangeOverrideFromQueryParam(
      window.location.search
    );

    if (queryParamValue === 'reset') {
      Cookies.remove(PDP_GALLERY_QA_COVER_RANGE_COOKIE);
      return undefined;
    }

    if (typeof queryParamValue === 'number') {
      Cookies.set(
        PDP_GALLERY_QA_COVER_RANGE_COOKIE,
        queryParamValue.toString()
      );
      return queryParamValue;
    }
  }

  return getGalleryCoverRangeOverrideFromCookie();
};
